import React, { useEffect, useState } from "react";
import DashboardContext from "../../context/dashboardContext";
import { requestCanceller } from "../../../service/axiosCancelToken";
import LoadingSpinner from "../../shared/LoadingSpinner";
import { getAllDocumentsCount } from './../../../service/adminService';


const GlobalState = props => {
    
    const [usersCount, setUsersCount] = useState();
    const [areaCount, setAreaCount] = useState();
    const [personsCount, setPersonsCount] = useState();
    const [ordersCount, setOrdersCount] = useState();
    const [orders2Count, setOrders2Count] = useState();
    const [placeCount, setPlaceCount] = useState();
    const [jobCategoryCount, setJobCategoryCount] = useState();
    const [productCategoryCount, setProductCategoryCount] = useState();
    const [placeCategoryCount, setPlaceCategoryCount] = useState();
    const [productCount, setProductCount] = useState();
    const [commentsCount, setCommentsCount] = useState();
    const [viewersCount, setViewersCount] = useState();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllDocumentsCount = async () => {
            try {
                setIsLoading(true);
                let { status, data } = await getAllDocumentsCount({cancelToken: cancelRequest.signal});
                if(status === 201){
                    setUsersCount(data.usersCount);
                    setAreaCount(data.areaCount);
                    setPersonsCount(data.personCount);
                    setOrdersCount(data.ordersCount);
                    setOrders2Count(data.orders2Count);
                    setPlaceCount(data.placeCount);
                    setProductCount(data.productCount);
                    setJobCategoryCount(data.jobCategoryCount);
                    setProductCategoryCount(data.productCategoryCount);
                    setPlaceCategoryCount(data.placeCategoryCount);
                    setCommentsCount(data.commentsCount);
                    setViewersCount(data.viewersCount);
                }
                setIsLoading(false);
            } catch (err) {

            }
        }
        fetchAllDocumentsCount();
        return () => {
			cancelRequest.cancel();
        }
    },[]);

    return (
        <DashboardContext.Provider
            value={{
                usersCount,
                setUsersCount,
                areaCount,
                setAreaCount,
                personsCount,
                setPersonsCount,
                ordersCount,
                setOrdersCount,
                orders2Count,
                setOrders2Count,
                placeCount,
                setPlaceCount,
                productCount,
                setProductCount,
                jobCategoryCount,
                setJobCategoryCount,
                productCategoryCount,
                setProductCategoryCount,
                placeCategoryCount,
                setPlaceCategoryCount,
                commentsCount,
                setCommentsCount,
                viewersCount,
                isLoading

            }}
        >
            {
                isLoading ? 
                <div style={{ height: '100vh' }} className="d-flex">
                    <div className="text-center align-self-center mx-auto">
                        <LoadingSpinner />
                    </div>
                </div> : 
                props.children
            }
        </DashboardContext.Provider>
    );
};

export default GlobalState;
